

// Импортируем необходимые js-файлы Bootstrap 4
// = ../../bower_components/bootstrap/js/src/util.js


// Импортируем другие js-файлы




/**
* JQuery Simple MobileMenu
* Copyright (c) 2017 Position2 Inc.
* Licensed under MIT (http://opensource.org/licenses/MIT)
* https://github.com/Position2/jQuery-Simple-MobileMenu
*/
(function($) {
  var defaults = {  
                    "hamburgerId"   : "sm_menu_ham", //Hamburger Id
                    "wrapperClass"  : "sm_menu_outer", //Menu Wrapper Class
                    "submenuClass"  : "submenu", //Submenu Class
                    "onMenuLoad"    : function() { return true; }, //Calls when menu loaded
                    "onMenuToggle"  : function() { return true; } //Calls when menu open/close
                  };
  $.fn.slideMobileMenu = function(options) {
    if (this.length === 0) { return this; }
    var smMenu = {}, ds = $(this);
    var init = function() {
          smMenu.settings = $.extend({}, defaults, options);
          // Create Wrapper div & hamburger
          createWrapper_Ham();
          // Create Back Menu for each sub menu
          createBackButton();
          // Callback - Menu loaded
          if(typeof smMenu.settings.onMenuLoad == 'function') {
            smMenu.settings.onMenuLoad(ds);
          }
        },
        createWrapper_Ham = function() {
          smMenu.hamburger = $("<div/>",{ "id"   : smMenu.settings.hamburgerId}),
          smMenu.smmOuter = $("<div/>",{ "class" : smMenu.settings.wrapperClass });
          ds.appendTo(smMenu.smmOuter);
          smMenu.hamburger.add(smMenu.smmOuter).appendTo($("body"));
        },
        createBackButton = function() {
          smMenu.smmOuter.find("ul."+smMenu.settings.submenuClass).each(function() {
            var dis     = $(this),
                disPar  = dis.closest("li"),
                disfA   = disPar.find("> a"),
                disBack = $("<li/>",{ 
                              "class" : "back",
                              "html"  : "<a href='#'>Назад</a>" })   // "html"  : "<a href='#'>"+disfA.text()+"</a>" })
            disPar.addClass("hasChild");
            disBack.prependTo(dis);
          });
        },
        toggleMobileMenu = function(e) {
          $("#"+smMenu.settings.hamburgerId).toggleClass("open");
          $("."+smMenu.settings.wrapperClass).toggleClass("active").find("li.active").removeClass("active");
          $("body").toggleClass("m-menu-opened");
          // Callback - Menu Toggle
          if(typeof smMenu.settings.onMenuToggle == 'function') {
            smMenu.settings.onMenuToggle(ds,$("#"+smMenu.settings.hamburgerId).hasClass("open"));
          }
        },
        showSubMenu = function(e) {
          e.preventDefault();
          $("."+smMenu.settings.wrapperClass).scrollTop(0);
          $(this).parent().addClass("active").siblings().removeClass("active");
        },
        goBack = function(e) {
          e.preventDefault();
          $(this).closest("ul."+smMenu.settings.submenuClass).parent().removeClass("active");
        }
    /*Init*/
    init();
    /* Open Menu */
    // smMenu.hamburger.click(toggleMobileMenu);
    $('.show-mobile-menu').click(toggleMobileMenu);

    /* Show SubMenu */
    smMenu.smmOuter.find("li.hasChild > a").click(showSubMenu);
    /* Go Back */
    smMenu.smmOuter.find("li.back a").click(goBack);
  };
})(jQuery)



$(".mobile-menu-block").slideMobileMenu({

  // Hamburger Id
  "hamburgerId"   : "sm_menu_ham", 

  // Menu Wrapper Class
  "wrapperClass"  : "sm_menu_outer", 

  // Submenu Class
  "submenuClass"  : "submenu", 

  // Calls when menu loaded
  "onMenuLoad"    : function() { return true; }, 

  // Calls when menu open/close
  "onMenuToggle"  : function() { return true; } 
  
});
$( document ).ready(function() {  
    var paddingTop = parseInt($("body").css("padding-top")),
        headerHeight = $('.mobile-header').outerHeight(),
        offsetTop = paddingTop + headerHeight + 'px',
        bodyHeight = $('body').outerHeight();

    $(window).scroll(function(){
        if ($(this).scrollTop() > 0) {
            $('.mobile-header').addClass('mobile-header_fix');
            // $('.user-content').css('paddingTop', offsetTop);   
        } else {
            $('.mobile-header').removeClass('mobile-header_fix');
            // $('.user-content').css('paddingTop', 0);
        }
    }); 


    //

});
function show_hide (blockId) { 
    if ($(blockId).css('display') == 'none') 
        { 
            $(blockId).slideDown('fast','linear');
        } 
    else 
        {     
            $(blockId).slideUp('fast','linear');
        } 
};




// Показываем инпут при выборе типа пополнения карты "Транспортный кошелек"
$(document).ready(function () { 
	$('input[name=pay-type]').click(function () {
	    if (this.id == "radio-1") {
	        $("#js-show-when-radio-1").slideDown(300);
	    } else {
	        $("#js-show-when-radio-1").slideUp(300);
	    }
	});

});
/* Аккордеон */
! function(i) {
      var o, n;
      i(".accordion-item--title").on("click", function() {
        o = i(this).parents(".accordion-item"), n = o.find(".accordion-item--content"),
          o.hasClass("accordion-item_opened") ? (o.removeClass("accordion-item_opened"),
            n.slideUp(200)) : (o.addClass("accordion-item_opened"), n.stop(!0, !0).slideDown(200),
            o.siblings(".accordion-item_opened").removeClass("accordion-item_opened").children(
              ".accordion-item--content").stop(!0, !0).slideUp(200))
      })
    }(jQuery);


/* Аккордеон end*/
$(document).ready(function () {
    $('.modal').on('shown.bs.modal', function (e) {
      // window.location.href = '#' + $(this).attr('data-m');
      window.location.href = '#' + 'modal-opened';
    });

    $('.modal').on('hidden.bs.modal', function (e) {
      history.pushState('', document.title, window.location.pathname);
    });

    $(window).bind('hashchange', function() {
      if(window.location.hash == ''){
        $('.modal').modal('hide');
      }
    });
});


// $(function() {
//   return $(".modal").on("show.bs.modal", function() {
//     var curModal;
//     curModal = this;
//     $(".modal").each(function() {
//       if (this !== curModal) {
//         $(this).modal("hide");
//       }
//     });
//   });

// });




// $(document).ready(function () {
//   var modal_counter = 0;
//   $('.modal').on('shown.bs.modal', function () {
//       var curModal;
//       curModal = this;
//       $(".modal").each(function() {
//         if (this !== curModal) {
//           $(this).modal("hide");
//            $('body').removeClass('modal-open');
//         }
//       });
//   });
//   // $('.modal').on('hidden.bs.modal', function () {
//   //     $('body').removeClass('modal-open');
//   // });
// })




$(document).ready(function () {
  $('.s-l-icon').click(function(){
      $('.modal').hide();
      $('body').removeClass('modal-open');
      $('.modal-backdrop').hide();
      $('body').css('padding-right','0');
  });
})